var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommercialCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 171,
    viewBox: "0 0 213 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.5599 119.488C68.2739 119.488 59.9355 111.339 59.9355 101.287C59.9355 91.2349 68.2739 83.086 78.5599 83.086C78.9973 83.086 79.4311 83.1008 79.861 83.1298C79.5623 81.4672 79.4064 79.7552 79.4064 78.0067C79.4064 62.1102 92.293 49.2236 108.189 49.2236C120.88 49.2236 131.653 57.4369 135.481 68.838C136.388 68.7431 137.31 68.6945 138.242 68.6945C152.502 68.6945 164.062 80.065 164.062 94.0913C164.062 107.417 153.629 118.411 140.359 119.47V119.488H92.5347H78.5599ZM88.7152 119.488H82.8192Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7152 119.488H82.8192M78.5599 119.488C68.2739 119.488 59.9355 111.339 59.9355 101.287C59.9355 91.2349 68.2739 83.086 78.5599 83.086C78.9973 83.086 79.4311 83.1008 79.861 83.1298C79.5623 81.4672 79.4064 79.7552 79.4064 78.0067C79.4064 62.1102 92.293 49.2236 108.189 49.2236C120.88 49.2236 131.653 57.4369 135.481 68.838C136.388 68.7431 137.31 68.6945 138.242 68.6945C152.502 68.6945 164.062 80.065 164.062 94.0913C164.062 107.417 153.629 118.411 140.359 119.47V119.488H92.5347H78.5599Z",
    stroke: "#00D9BE",
    strokeWidth: 2.1164,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.3962 55.4398C99.3962 82.7186 123.964 105.197 155.597 108.232C151.633 113.106 145.511 116.413 138.537 116.933V116.949H81.7291C74.8366 116.949 63.3223 114.045 63.3223 101.328C63.3223 88.6117 72.2739 85.7078 81.7291 85.7078C82.1311 85.7078 82.53 85.7204 82.9251 85.7453C82.6506 84.3185 82.6023 82.8479 82.5073 81.3486C81.8651 71.221 86.2835 58.4573 99.4114 54.3032C99.4009 54.6819 99.3962 55.0604 99.3962 55.4398ZM108.288 98.1194C105.716 98.1194 103.631 100.18 103.631 102.722C103.631 105.264 105.716 107.325 108.288 107.325C110.861 107.325 112.946 105.264 112.946 102.722C112.946 100.18 110.861 98.1194 108.288 98.1194Z",
    fill: "#74F8BE",
    fillOpacity: 0.12
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.613 107.636C111.185 107.636 113.269 105.552 113.269 102.98C113.269 100.409 111.185 98.3242 108.613 98.3242C106.042 98.3242 103.957 100.409 103.957 102.98C103.957 105.552 106.042 107.636 108.613 107.636Z",
    stroke: "#00D9BE",
    strokeWidth: 2.1164
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4912 93.2446L101.417 88.5944L95.4912 84.1675",
    stroke: "#00D9BE",
    strokeWidth: 2.1164,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M121.734 93.2446L115.808 88.5944L121.734 84.1675",
    stroke: "#00D9BE",
    strokeWidth: 2.1164,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.655 57.6895C122.165 59.1477 126.516 63.4569 128.033 68.9429",
    stroke: "#73F5CF",
    strokeWidth: 2.1164,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M134.433 43.2976C135.836 43.2976 136.973 42.1606 136.973 40.7579C136.973 39.3553 135.836 38.2183 134.433 38.2183C133.031 38.2183 131.894 39.3553 131.894 40.7579C131.894 42.1606 133.031 43.2976 134.433 43.2976Z",
    stroke: "#73F5CF",
    strokeWidth: 1.69312
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M160.676 56.8425C162.079 56.8425 163.216 55.7055 163.216 54.3029C163.216 52.9002 162.079 51.7632 160.676 51.7632C159.274 51.7632 158.137 52.9002 158.137 54.3029C158.137 55.7055 159.274 56.8425 160.676 56.8425Z",
    fill: "#73F5CF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M141 49.8647L148.076 56.9405M148.183 49.8647L141.108 56.9405L148.183 49.8647Z",
    stroke: "#73F5CF",
    strokeWidth: 2.1164,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.124 64.9663L66.2034 70.0457M66.2034 64.9663L61.124 70.0457L66.2034 64.9663Z",
    stroke: "#73F5CF",
    strokeWidth: 2.1164,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6344 59.3826C74.037 59.3826 75.1741 58.2455 75.1741 56.8429C75.1741 55.4403 74.037 54.3032 72.6344 54.3032C71.2318 54.3032 70.0947 55.4403 70.0947 56.8429C70.0947 58.2455 71.2318 59.3826 72.6344 59.3826Z",
    fill: "#73F5CF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommercialCloud);
export default __webpack_public_path__ + "static/media/commercial-cloud.cc14fc03655b4c7b570c6788190f41e5.svg";
export { ForwardRef as ReactComponent };